import React from 'react';
import { InputField } from 'vindi-ds-components';

function ProductName() {
  return (
    <>
      <InputField
        style={{ width: '23.6em' }}
        label='Nome do Produto'
        name='name'
        placeholder='Nome'
      />
    </>
  );
}

export default ProductName;
